import React from 'react';
import DataTable, { TableColumn } from 'react-data-table-component';
import TipoDocumento from './TipoDocumento';




interface TipoDocumentoTableProps {
  data: TipoDocumento[];
  columns: TableColumn<TipoDocumento>[];
  customStyles: Record<string, any>;
}

const TipoDocumentoTable: React.FC<TipoDocumentoTableProps> = ({ data, columns, customStyles }) => {
  return (
    <DataTable<TipoDocumento>
      columns={columns}
      data={data}
      pagination
      paginationComponentOptions={{
        rowsPerPageText: 'Filas por página:',
        rangeSeparatorText: 'de'
      }}
      paginationPerPage={10}
      paginationRowsPerPageOptions={[10, 20, 30]}
      customStyles={customStyles}
      noDataComponent={"No hay registros para mostrar."}
    />
  );
};

export default TipoDocumentoTable;